module.exports = __webpack_public_path__ + "static/media/password.c79c60df.svg";